<template>
    <mdb-navbar id="topHeaderNav" class="newbg z-depth-0 pt-0 pb-0 d-none d-md-block d-lg-block" dark  style="z-index: 150">
        <mdb-navbar-toggler class="container">
            <ul right class="list-inline ml-auto my-0" >
                <li v-for="(link, index) in links" :key="index" class="list-inline-item mr-4" >
                    <router-link :to="link.to"><img :src="link.icon" /> {{ link.name }}</router-link>
                </li>
                <li class="list-inline-item mr-4" v-if="user_name">
                    <mdb-dropdown tag="li">
                        <mdb-dropdown-toggle tag="a" navLink color="" slot="toggle" style="overflow: inherit;color:white"><img src="../assets/images/Giris.png" /> {{ user_name }}</mdb-dropdown-toggle>
                        <mdb-dropdown-menu>
                            <mdb-dropdown-item><router-link to="/profile"><mdb-icon fas icon="user-cog" /> Profilim</router-link></mdb-dropdown-item>
                            <mdb-dropdown-item><router-link to="/biletlerim"><mdb-icon fas icon="ticket-alt" /> Biletlerim</router-link></mdb-dropdown-item>
                            <mdb-dropdown-item></mdb-dropdown-item>
                            <div class="dropdown-divider"></div>
                            <mdb-dropdown-item @click="logOut"><mdb-icon fas icon="unlock" /> Çıkış Yap</mdb-dropdown-item>
                        </mdb-dropdown-menu>
                    </mdb-dropdown>
                </li>
                <li class="list-inline-item mr-4" v-else>
                    <router-link to="/register-login"><img src="../assets/images/Giris.png" /> Giriş yap veya Üye ol</router-link>
                </li>
            </ul>
        </mdb-navbar-toggler>
    </mdb-navbar>
</template>

<script>
    import { mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbInput, mdbDropdownItem, mdbIcon } from 'mdbvue';
    export default {
        name: 'topheader.vue',
        components: {
            mdbNavbar,
            mdbNavbarBrand,
            mdbNavbarToggler,
            mdbNavbarNav,
            mdbNavItem,
            mdbDropdown,
            mdbDropdownMenu,
            mdbDropdownToggle,
            mdbDropdownItem,
            mdbInput,
            mdbIcon
        },
        data () {
            return {
                user_name:'',
                links : [
                    {
                        name: 'İletişim',
                        to: '/iletisim',
                        icon : require('../assets/images/iletisim.png')
                    },
                    /*{
                        name: 'yardım',
                        to: '/p/yardim',
                        icon : require('../assets/images/Yardim.png')
                    },
                    {
                        name: 'Hızlı İade & İptal İşlemi',
                        to: '/p/iade_iptal',
                        icon : require('../assets/images/Hizli.png')

                    }*/
                ]

            }
        },
        methods:{
            logOut(){
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_email');
                localStorage.removeItem('api_token');
                window.location = "/";
            }
        },
        mounted() {
            if (localStorage.user_name) {
                this.user_name = localStorage.user_name;
            }
        }
    }
</script>

<style scoped>

</style>
